<template>
  <div class="warp warp_enterprise warp_zhapin" v-if="data">
    <Head></Head>
    <div class="modle_1 " :style="'background: url('+data.img2+') center no-repeat;'">
      <div class="txt_box">
        <div class="t1 swashIn">

          {{data.encatname}}
        </div>
        <div class="t2">
          {{data.catname}}
        </div>
        <div class="t3">

          {{data.seodescription}}
        </div>
      </div>
      <ChildBan></ChildBan>
    </div>


    <div class="modle_7">

      <div class="cm_title">

        <div class="t1" v-scroll-reveal>
          MANAGEMENT TEAM
        </div>

        <div class="t2" v-scroll-reveal>
          公司管理
        </div>

      </div>
    </div>

    <div class="modle_17 cle">

      <div class="let fl" v-scroll-reveal>
        <img :src="data.list[0].img1" style="width: 100%;" />
      </div>

      <div class="rit fr">
        <div class="t1" v-scroll-reveal>
          {{data.list[0].title}} <span>{{data.list[0].tags}}</span>
        </div>
        <div class="t2" v-scroll-reveal v-html="data.list[0].introduce">


        </div>
      </div>

    </div>

    <div class="modle_18">

      <img src="/static/img/p17.png" v-scroll-reveal />

    </div>

    <div class="modle_19">

      <div class="box">
        <div class="t1" v-scroll-reveal>
          {{data.list[1].title}} <span>{{data.list[1].tags}}</span>
        </div>
        <div class="cont" v-scroll-reveal v-html="data.list[1].introduce">



        </div>
      </div>
      <img v-scroll-reveal :src="data.list[1].img1" class="sho_img" />

    </div>

    <div class="modle_20">
      <div class="group cle">
        <div class="item fl" v-scroll-reveal v-for="(item,index) in data.list" :key="index" v-if="index >= 2 ? true : false">
          <div class="img">
            <img :src="item.img1" />
          </div>
          <div class="cont">


            <div class="t1">
              <span>{{item.title}} </span> {{item.tags}}
            </div>
            <div class="t2" v-html="item.introduce">


            </div>
          </div>
        </div>
      </div>
    </div>



    <img src="/static/img/p18.png" v-scroll-reveal style="width: 100%;" />


  </div>
</template>

<script>
  import {
    postteamAPI
  } from '../../../api/api.js'
  import Head from '@/components/Head.vue'
  import ChildBan from '@/components/ChildBan.vue'

  export default {
    components: {
      Head,
      ChildBan
    },
    data() {
      return {
        sle_int: 0, //下表
        data: null, //
        data_list: null


      }
    },
    methods: {
      //获取案例信息
      getList() {
        var that = this;
        postteamAPI().then(function(res) {
          that.data = res.data.data;

          //  console.log(that.data_list[0].list);
        }).catch(function(err) {
          console.log(err);
        })
      },


    },
    mounted() {
      this.getList();

    }

  }
</script>

<style lang="less" scoped>
  // 引入公共css3
  @import '../../assets/css3.css';

  template {
    min-height: 100%;
  }


  html,
  body {
    position: relative;
    min-height: 100%;
    overflow-x: hidden;
  }

  

  .modle_1 {
    height: 1200px;
    width: 100%;
    background: #f5f5f5;
    position: relative;

    .txt_box {
      position: relative;
      top: 500px;
      padding: 0px 50px;
      text-align: left;

      .t1 {
        color: #fff;
        font-size: 138px;
        font-weight: bold;
        margin-bottom: 20px;
      }

      .t2 {
        color: #fff;
        font-size: 80px;
      }

      .t3 {
        color: #fff;
        opacity: 0.5;
        margin-top: 115px;
        font-size: 37px;
      }
    }
  }

  .modle_7 {
    margin: 0px 135px;
    margin-top: 160px;

    .cm_title {
      text-align: center;
      margin-bottom: 125px;

      .t1 {
        font-size: 93px;
        color: #000000;
        font-weight: bold;
        margin-bottom: 40px;
      }

      .t2 {
        font-size: 50px;
        color: #000000;
        letter-spacing: 15px;
      }
    }
  }

  .modle_17 {
    width: 95%;
    max-width: 1200px;
    margin: 0px auto;
    margin-top: 140px;

    .let {
      width: 24%;
      padding-top: 15px;

    }

    .rit {
      width: 71%;
      text-align: left;

      .t1 {
        font-size: 43px;
        color: #2B2B2B;
        margin-bottom: 40px;
        font-weight: bold;

        span {
          font-size: 30px;
        }
      }

      .t2 {
        font-size: 18px;
        color: #2B2B2B;
        line-height: 50px;
      }
    }
  }

  .modle_18 {
    text-align: right;
    padding-right: 10px;
  }

  .modle_19 {
    background: #f7f7f7;
    position: relative;

    .box {
      width: 95%;
      max-width: 1200px;
      margin: 0px auto;
      text-align: left;
      padding: 85px 0;

      .t1 {
        color: #2B2B2B;
        font-weight: bold;
        font-size: 43px;
        margin-bottom: 50px;

        span {
          font-size: 30px;
        }
      }

      .cont {
        font-size: 18px;
        width: 800px;
        color: #2B2B2B;
        line-height: 50px;
      }
    }

    .sho_img {
      position: absolute;
      right: 0px;
      top: 0px;
      height: 100%;
    }

  }


  .modle_20 {
    margin: 0px 160px;
    margin-top: 170px;

    .group {
      .item {
        width: 20%;
        margin: 0px 2.5%;

        .img {}

        .t1 {
          margin: 30px 0;
          font-size: #2B2B2B;
          font-size: 28px;
          font-weight: bold;

          span {
            font-size: 43px;
          }
        }

        .t2 {
          font-size: 16px;
          line-height: 30px;
          color: #2B2B2B;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/view/administration/administration.vue